import React from 'react';

import { MembershipConfigWatcher } from 'hoc/withMembershipConfig';

/**
 * @function
 * This HOC defines how a children element should be displayed given some membership config.
 * @param {JSX.Element} WrappedComponent Component to be tested through a set of conditions.
 * @param {Array} conditions Array with conditions that define the behavior of a children component.
 */
const withMembershipConfig = (WrappedComponent, conditions) => {
  return (props) => (
    <MembershipConfigWatcher conditions={conditions}>
      <WrappedComponent {...props} />
    </MembershipConfigWatcher>
  );
};

export default withMembershipConfig;
